"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.telemetrySender = void 0;
var typescript_telemetry_forwarder_1 = require("@tableau/typescript-telemetry-forwarder");
var reselect_1 = require("reselect");
var uuid_1 = require("uuid");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
var TelemetrySender = /** @class */ (function () {
    function TelemetrySender() {
        /**
         * TelemetryService handles sending telemetry events to the Google Big Query database.
         *
         * App-wide event properties get set through the reporter and eventFactory
         * Usage examples: UrlTelemetryService.ts for Angular and SiteSpace.tsx for React
         *
         * For setting up events in Google BigQuery, see https://mytableau.tableaucorp.com/x/0hOHBw
         */
        var _this = this;
        // telemetry-contract-api requires this particular signature for its callback
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.telemetryContractApiCallback = undefined;
        this.telemetryVizClientApiCallback = undefined;
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.setTelemetryContractApiCallback = function (callback) {
            _this.telemetryContractApiCallback = callback;
        };
        this.setTelemetryVizClientApiCallback = function (callback) {
            _this.telemetryVizClientApiCallback = callback;
        };
        this.getTelemetryForwarder = (0, reselect_1.defaultMemoize)(function () { return new typescript_telemetry_forwarder_1.TelemetryForwarder(); });
    }
    TelemetrySender.prototype.sendEvent = function (event, telemetryContext, valueHandling) {
        var _a = event, type = _a.type, customProps = __rest(_a, ["type"]);
        var properties = __assign(__assign({}, customProps), this.getCommonProperties(telemetryContext));
        switch (valueHandling) {
            case 'empty':
                Object.keys(properties).forEach(function (key) {
                    // since remove waitingForSession or getSessionInfo before we send telemetry, values of sessionInfo could be null
                    // vizportal java code does not allow null value, so need convert to empty string
                    if (properties[key] === undefined || properties[key] === null) {
                        properties[key] = '';
                    }
                });
                break;
            case 'remove':
                for (var key in properties) {
                    if (properties[key] === undefined) {
                        delete properties[key];
                    }
                }
                break;
            default:
                (0, TypescriptHelpers_1.assertUnreachable)(valueHandling);
        }
        // java-event-client use NetworkUtilities.getHostName() to get hostName, so we do not need to add hostName
        // https://gitlab.tableausoftware.com/Product-Analytics/java-event-client/blob/master/src/main/java/com/tableau/telemetry/event/AEvent.java#L27
        var params = (0, typescript_telemetry_forwarder_1.createReportEventUnauthenticatedParams)(type, 'datacatalog', properties);
        // When called from Hybrid UI on Desktop and Server, we can't send telemetry directly and instead have to
        // use the callback they provide.
        if (this.telemetryContractApiCallback) {
            var payload_1 = new Array();
            Object.keys(properties).forEach(function (key) {
                // push as a "name value pair"
                payload_1.push(key, properties[key]);
            });
            this.telemetryContractApiCallback(type, payload_1);
        }
        else if (this.telemetryVizClientApiCallback) {
            this.telemetryVizClientApiCallback(type, properties);
        }
        else {
            this.getTelemetryForwarder().send(params);
        }
    };
    TelemetrySender.prototype.getCommonProperties = function (telemetryContext) {
        return __assign(__assign({}, telemetryContext), { uuid: (0, uuid_1.v4)() });
    };
    TelemetrySender.prototype.resetTelemetryContractApiCallback = function () {
        this.telemetryVizClientApiCallback = undefined;
    };
    return TelemetrySender;
}());
exports.telemetrySender = new TelemetrySender();
//# sourceMappingURL=TelemetrySender.js.map